import {
	IonApp,
	IonCol,
	IonContent,
	IonInfiniteScroll,
	IonInfiniteScrollContent,
	IonLoading,
	IonPage,
} from "@ionic/react";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import NavFooter from "components/mobile-components/Common/NavFooter";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Product from "services/Product";

export default function LeaveListPage() {
	const ekkLanguage = useSelector((state) => state.lan.lan);
	const [hasMoreData, setHasMoreData] = useState(true);
	const [reachedEnd, setReachedEnd] = useState(false);
	const [pageCount, setPageCount] = useState(2);
	const [leaveList, setLeaveList] = useState([]);
	const { id } = useParams();
	const dateFormat = useSelector((state) => state.date.format);
	const [leaveLoading, setLeaveLoading] = useState(false);

	const getEmployeesLeaveList = async (id) => {
		setLeaveLoading(true);
		let response = await Product.getEmployeeLeaveList(id);
		if (response.status === 200) {
			setLeaveList(response.results);
			setLeaveLoading(false);
		} else {
			setLeaveLoading(false);
		}
	};
	let loadMoreData = async () => {
		if (hasMoreData) {
			let response = await Product.getEmployeeLeaveList(id, pageCount, 50);
			if (response.status === 200) {
				setPageCount((prev) => prev + 1);
				setLeaveList([...leaveList, ...response.results]);
			} else {
				setHasMoreData(false);
			}
		}
	};

	useEffect(() => {
		getEmployeesLeaveList(id);
	}, []);

	return (
		<IonApp>
			<IonPage>
				<IonContent style={{ "--background": "#fff" }}>
					<BackButtonTitle title='Leave List' />
					<section className='pt-14'>
						{leaveLoading ? (
							<IonLoading
								isOpen={true}
								message={ekkLanguage.orderList?.loader}></IonLoading>
						) : (
							<>
								<div>
									<div className='px-4 py-[10px]'>
										<div className='flex justify-between items-center'>
											<h6 className='font-bold text-16 pt-4 pb-4'>
												Employee Leave
											</h6>
										</div>

										<div className='mb-4'>
											<table className='table-auto w-full bg-white'>
												<thead>
													<tr className='border h-[45px] border-r-0 border-l-0 border-D9D9D9 px-4'>
														<th className='font-bold text-14'>
															Date
														</th>
														<th className='font-bold text-14'>
															Leave Type
														</th>
														<th className='font-bold text-14'>
															Status
														</th>
														<th className='font-bold text-14'>
															Approved By
														</th>
													</tr>
												</thead>

												<tbody>
													{leaveList?.length > 0 &&
														leaveList?.map((el, i) => (
															<tr
																key={i}
																className='text-center h-[34px] border border-r-0 border-l-0 border-D9D9D9 px-4'
																// onClick={() => {
																// 	setSelectedHours(el);
																// 	setTotalWorkingHours(el?.working_hour);
																// 	onOpenModalEditHours();
																// }}
															>
																<td className='font-semibold text-12'>
																	{moment(
																		el?.start_date
																	).format(`${dateFormat}`)}
																	-
																	{moment(
																		el?.start_end
																	).format(`${dateFormat}`)}
																</td>
																<td className='font-semibold text-12'>
																	{el?.leave_type}
																</td>
																<td className='font-semibold text-12'>
																	{el?.status}
																</td>
																<td className='font-semibold text-12'>
																	{el?.approved_by_name}
																</td>
															</tr>
														))}
												</tbody>
											</table>

											{leaveList.length === 0 && (
												<>
													<IonCol size='2'></IonCol>
													<IonCol size='8'>
														<div
															className='text-center flex items-center justify-center'
															style={{
																height: "calc(100vh - 420px)",
															}}>
															<div>
																<img
																	className='m-auto mb-[10px] mt-5'
																	src='/assets/images/not-found-file.png'
																	alt='emptyCard'
																/>
																<p className='text-16 font-normal text-222222 mb-[35px]'>
																	{
																		ekkLanguage.orderList
																			.notFound
																	}
																</p>
															</div>
														</div>
													</IonCol>
												</>
											)}
										</div>
									</div>
								</div>
							</>
						)}
					</section>
					<IonInfiniteScroll
						onIonInfinite={(ev) => {
							if (reachedEnd) {
								ev.target.complete();
								return;
							}
							loadMoreData();
							setTimeout(() => {
								ev.target.complete();
								if (!hasMoreData) {
									setReachedEnd(true);
								}
							}, 1000);
						}}>
						<IonInfiniteScrollContent
							loadingText={ekkLanguage.orderList.loader}
							loadingSpinner={
								hasMoreData ? "bubbles" : null
							}></IonInfiniteScrollContent>
					</IonInfiniteScroll>
				</IonContent>
				{/* <NavFooter /> */}
			</IonPage>
		</IonApp>
	);
}
